/* Impression SCDM - le montant envoye au panier. C est le fichier de l argent.

   CE QU IL FAIT
   -------------
   Il remplace l envoi au panier de scdm.js. Trois raisons, dans l ordre
   d importance :

   1. LE RABAIS EST APPLIQUE ICI, ET NULLE PART AILLEURS. Il n y a plus aucun
      rabais dans Shopify - ni code, ni rabais automatique. Le configurateur
      calcule le prix, applique la promotion, et envoie au panier le montant
      DEJA escompte. Shopify ne fait qu encaisser ce qu on lui donne. C est la
      seule facon d avoir un seul rabais : celui qu on a montre au client.
      Avant, le site affichait le rabais et Shopify l appliquait de son cote ;
      garder les deux systemes, c etait risquer de le compter deux fois.

   2. TOUT PASSE PAR LE PRODUIT TECHNIQUE. La boutique ne vend aucun article a
      prix fixe : un autocollant n a pas de prix fixe, le montant depend de la
      grandeur ET de la quantite. On vide donc VARIANTES, et les six anciens
      produits de format sont restes archives.

   3. ON COMPTE EN CENTS. Le produit technique vaut 0,01 $ l unite et la
      quantite porte le montant : 65,45 $ = 6545 unites. Avec l ancien produit
      a 1,00 $, un rabais de 15 % tombait presque toujours sur des cents qu il
      fallait arrondir - le client voyait 65,45 $ et payait 65,00 $. Au Quebec
      un prix annonce doit etre honore : l ecart devait disparaitre, pas
      retrecir. L ecart d arrondi restant, au plus un cent, est verse sur la
      premiere ligne pour que la somme des lignes fasse EXACTEMENT le total
      affiche.

   CE QUI PART SUR LA COMMANDE
   ---------------------------
   Chaque ligne porte son prix avant rabais, le nom de la promotion et, si
   c est un code, le code lui-meme. C est ce qui permet de compter combien de
   fois chaque code a servi : Shopify ne les connait plus, donc il ne les
   compte plus. La comptabilite se fait sur les commandes.

   A FAIRE UN JOUR : replier ce fichier dans scdm.js (fonction
   envoyerAuPanier). Il vit a part uniquement pour eviter de reecrire un
   fichier de 39 Ko. */

(function () {
  'use strict';

  /* ==================================================================
     LA SOUMISSION PRE-REMPLIE

     ⚠️ CE BLOC EST VOLONTAIREMENT AVANT LE GARDE-FOU « if (!D) return ».
     Sur /pages/soumission, SCDM_DATA n existe pas - tout le reste de ce
     fichier n a rien a y faire - mais ce fichier-ci est le SEUL des nos
     scripts charge sur toutes les pages. C est donc ici que la demande
     montee dans le configurateur se depose dans le formulaire.

     Pourquoi sessionStorage et pas l adresse : le resume fait plusieurs
     centaines de caracteres, et une adresse ne doit jamais porter le
     detail d une commande.
     ================================================================== */
  /* ==================================================================
     ⚠️ LE BOUTON MUET DE LA PAGE DE SOUMISSION

     MESURE LE 9 SEPTEMBRE, sur la page en ligne. Un client remplit son
     nom, son courriel et sa description, oublie « Type de projet »,
     clique « Envoyer ma demande » : IL NE SE PASSE RIEN. Pas de message,
     pas de champ souligne, pas meme un clignotement du bouton. Il clique
     deux fois, trois fois, et il s en va.

     POURQUOI. Le correctif de la piece jointe, le 7 septembre, a du
     passer le bouton en type="button" - c etait la seule facon
     d empecher le captcha de soumettre le formulaire AVANT la fin du
     televersement. Mais un bouton de ce type ne declenche plus la
     validation native du navigateur : la bulle « Veuillez selectionner
     un element dans la liste » n apparait jamais. Le formulaire est
     invalide, et personne ne le dit.

     LA PREUVE, mesuree deux fois : « Type de projet » vide, deux clics ->
     ZERO evenement submit, ZERO appel a requestSubmit. Le champ choisi,
     un seul clic -> requestSubmit part. C est bien la validation qui
     bloque, en silence.

     CE QU ON FAIT. On regarde en phase de CAPTURE SUR WINDOW - donc avant
     tout le monde, y compris le gestionnaire qui se tait. Si le
     formulaire est invalide : on le dit, on souligne les champs fautifs,
     et on amene le premier sous les yeux du client.
     ================================================================== */

  var CLE_NUMERO = 'scdmNumeroDemande';
  var CLE_NUMERO_TRANSMIS = 'scdmNumeroDemandeTransmis';
  var CLE_NUMERO_RECU = 'scdmNumeroDemandeRecu';

  function texteSoumissionValidation(cle, repli, params) {
    var racine = document.querySelector('[data-quote-validation]');
    var texte = racine && racine.getAttribute('data-quote-validation-' + cle);
    return (texte || repli).replace(/\{([a-z_]+)\}/g, function(mot, nom) {
      return params && Object.prototype.hasOwnProperty.call(params, nom) ? String(params[nom]) : mot;
    });
  }

  function htmlSoumissionValidation(texte) {
    return String(texte).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  var LIBELLES_SOUMISSION = {
    's-nom': 'votre nom',
    's-mail': 'votre courriel',
    's-type': 'le type de projet',
    's-desc': 'la description de votre projet'
  };

  function reveillerLeBouton() {
    var f = document.getElementById('scdmSoumission');
    if (!f || f.__scdmReveille) return;
    f.__scdmReveille = true;

    var description = document.getElementById('s-desc');
    function validerDescription() {
      if (!description) return;
      var projet = description.value.split(/\n\n----- FICHIERS JOINTS -----\n/)[0]
        .replace(/^(?:N° de demande|Request number)\s*:\s*DS-\d{8}-\d{4}\s*$/gm, '').trim();
      description.setCustomValidity(projet ? '' : description.getAttribute('placeholder'));
    }
    if (description) description.addEventListener('input', validerDescription);
    validerDescription();
    f.addEventListener('submit', function (e) {
      validerDescription();
      if (description && !description.checkValidity()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        description.reportValidity();
      } else {
        poserLeNumero();
        try {
          var numeroTransmis = sessionStorage.getItem(CLE_NUMERO);
          if (/^DS-\d{8}-\d{4}$/.test(numeroTransmis || '')) sessionStorage.setItem(CLE_NUMERO_TRANSMIS, numeroTransmis);
        } catch (err) {}
      }
    }, true);

    function dire(texte) {
      var d = document.getElementById('scdmManque');
      if (!d) {
        d = document.createElement('div');
        d.id = 'scdmManque';
        d.className = 'msg-err';
        d.setAttribute('role', 'alert');
        f.insertBefore(d, f.firstChild);
      }
      d.innerHTML = '<strong>' + htmlSoumissionValidation(texteSoumissionValidation('missing_title', 'Il manque quelque chose.')) + '</strong><br>' + htmlSoumissionValidation(texte);
      return d;
    }

    /* ⚠️ SUR WINDOW, pas sur document : la capture passe par window en
       premier. C est le seul endroit qui garantit qu on parle avant le
       gestionnaire de scdm-soumission-fix.js. */
    window.addEventListener('click', function (e) {
      var t = (e.target && e.target.closest) ? e.target.closest('#scdmEnvoyer') : null;
      if (!t) return;
      validerDescription();
      if (f.checkValidity()) {
        var vieux = document.getElementById('scdmManque');
        if (vieux && vieux.parentNode) vieux.parentNode.removeChild(vieux);
        poserLeNumero();
        return;                           /* tout va bien : on laisse partir */
      }
      e.preventDefault();
      e.stopImmediatePropagation();

      var premier = null, noms = [];
      Array.prototype.forEach.call(f.querySelectorAll('[required]'), function (c) {
        if (!c.checkValidity) return;
        if (c.checkValidity()) { c.style.borderColor = ''; return; }
        if (!premier) premier = c;
        noms.push((LIBELLES_SOUMISSION[c.id] && texteSoumissionValidation('field_' + c.id.slice(2), LIBELLES_SOUMISSION[c.id])) ||
                  String(c.name || '').replace(/^contact\[|\]$/g, ''));
        c.style.borderColor = '#F05252';
      });
      if (!noms.length) noms.push(texteSoumissionValidation('required_field', 'un champ obligatoire'));
      var d = dire(noms.length > 1
        ? texteSoumissionValidation('missing_many', 'Il faut encore : {fields}.', { fields: noms.join(', ') })
        : texteSoumissionValidation('missing_one', 'Il faut encore {field}.', { field: noms[0] }));
      try { d.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (er) {}
      if (premier) { try { premier.focus({ preventScroll: true }); } catch (er) {} }
    }, true);

    /* Des que le client corrige, le soulignement rouge s en va. */
    function nettoyer(e) {
      var c = e.target;
      if (c && c.checkValidity && c.checkValidity()) c.style.borderColor = '';
    }
    f.addEventListener('input', nettoyer, true);
    f.addEventListener('change', nettoyer, true);
  }

  /* ==================================================================
     LE NUMERO DE DEMANDE

     POURQUOI. Shopify n envoie RIEN au client qui remplit un formulaire
     de contact - seul l atelier est averti, et c est une limite du
     formulaire, pas un reglage. Verifie le 9 septembre : ni Shopify
     Forms, ni Shopify Flow (dont l action de courriel est INTERNE) ne
     savent accuser reception au demandeur.

     A defaut d un courriel, le client repart au moins avec une prise :
     un numero, ecrit a l ecran ET dans le corps du message, donc present
     des deux cotes. Il peut le citer, l atelier peut le retrouver dans
     sa boite.

     Il est tire une seule fois par session : un rechargement ne doit pas
     donner un deuxieme numero pour la meme demande.
     ================================================================== */
  function numeroDeDemande() {
    var n = null;
    try { n = sessionStorage.getItem(CLE_NUMERO); } catch (e) {}
    if (n) return n;
    var d = new Date();
    function deux(x) { return (x < 10 ? '0' : '') + x; }
    n = 'DS-' + d.getFullYear() + deux(d.getMonth() + 1) + deux(d.getDate()) +
        '-' + String(Math.floor(1000 + Math.random() * 9000));
    try { sessionStorage.setItem(CLE_NUMERO, n); } catch (e) {}
    return n;
  }

  function poserLeNumero() {
    var recu = document.getElementById('scdmRecu');

    if (recu) {
      var n = null;
      var historique = window.history;
      var etatHistorique = null;
      try {
        etatHistorique = historique && historique.state;
        n = etatHistorique && etatHistorique.scdmRecuNumero;
      } catch (e) {}
      if (!/^DS-\d{8}-\d{4}$/.test(n || '')) {
        try { n = sessionStorage.getItem(CLE_NUMERO_TRANSMIS) || sessionStorage.getItem(CLE_NUMERO_RECU); } catch (e) {}
      }
      if (!/^DS-\d{8}-\d{4}$/.test(n || '')) return;
      try {
        sessionStorage.setItem(CLE_NUMERO_RECU, n);
        if (sessionStorage.getItem(CLE_NUMERO) === n) sessionStorage.removeItem(CLE_NUMERO);
        if (sessionStorage.getItem(CLE_NUMERO_TRANSMIS) === n) sessionStorage.removeItem(CLE_NUMERO_TRANSMIS);
      } catch (e) {}
      try {
        if (historique && typeof historique.replaceState === 'function') {
          historique.replaceState(Object.assign({}, etatHistorique || {}, { scdmRecuNumero: n }), '');
        }
      } catch (e) {}
      if (recu.getAttribute('data-scdm-reference') === n) return;
      recu.setAttribute('data-scdm-reference', n);
      var boite = recu.querySelector('.scdm-recu-b') || recu;
      var p = document.createElement('p');
      p.style.cssText = 'margin:10px 0 0;font-family:ui-monospace,Menlo,Consolas,monospace;' +
        'font-size:15px;letter-spacing:.04em';
      p.innerHTML = htmlSoumissionValidation(texteSoumissionValidation('your_reference', 'Votre n° de demande : ')) + '<b>' + htmlSoumissionValidation(n) + '</b>';
      var x = document.getElementById('scdmRecuX');
      if (x && x.parentNode === boite) boite.insertBefore(p, x);
      else boite.appendChild(p);
      var bandeau = document.querySelector('.msg-ok');
      if (bandeau) bandeau.innerHTML += '<br>' + htmlSoumissionValidation(texteSoumissionValidation('reference', 'N° de demande : ')) + '<b>' + htmlSoumissionValidation(n) + '</b>';
      return;
    }

    var champ = document.getElementById('s-desc');
    if (!champ) return;
    var num = numeroDeDemande();
    if (champ.value.indexOf(num) >= 0) return;
    champ.value = texteSoumissionValidation('reference', 'N° de demande : ') + num + '\n\n' + champ.value;
  }

  function deposerLaSoumission() {
    var CLE = 'scdmSoumissionAuto';
    var champ = document.getElementById('s-desc');
    if (!champ) return;                      /* on n est pas sur la soumission */

    var brut;
    try { brut = sessionStorage.getItem(CLE); } catch (e) { return; }
    if (!brut) return;
    /* On la retire tout de suite : un rechargement ne doit pas reecrire
       par-dessus ce que le client vient de corriger a la main. */
    try { sessionStorage.removeItem(CLE); } catch (e) {}

    var p;
    try { p = JSON.parse(brut); } catch (e) { return; }
    if (!p || !p.resume) return;

    function poser(id, val) {
      var e = document.getElementById(id);
      if (e && val) { e.value = val; e.dispatchEvent(new Event('input', { bubbles: true })); }
    }
    function choisir(id, motif) {
      var s = document.getElementById(id);
      if (!s) return;
      for (var i = 0; i < s.options.length; i++) {
        var v = (s.options[i].value || '') + ' ' + (s.options[i].textContent || '');
        if (motif.test(v)) { s.selectedIndex = i; return; }
      }
    }

    /* Un motif de recherche construit a partir d un LIBELLE, pas d un
       identifiant : le menu Materiau de la page est ecrit en francais, avec
       des accents et des entites HTML. On enleve les accents des deux cotes
       et on cherche le libelle dans le texte de l option. */
    function sansAccent(t) {
      return String(t || '').normalize ? String(t).normalize('NFD').replace(/[̀-ͯ]/g, '') : String(t || '');
    }
    function choisirLibelle(id, lb) {
      if (!lb) return;
      var s = document.getElementById(id);
      if (!s) return;
      var cible = sansAccent(lb).toLowerCase().replace(/\s+/g, ' ').trim();
      if (!cible) return;
      for (var i = 0; i < s.options.length; i++) {
        var v = sansAccent((s.options[i].value || '') + ' ' + (s.options[i].textContent || '')).toLowerCase().replace(/\s+/g, ' ');
        if (v.indexOf(cible) !== -1) { s.selectedIndex = i; return; }
      }
    }

    poser('s-desc', p.resume + (champ.value ? '\n\n' + champ.value : ''));
    poser('s-format', p.format);
    poser('s-qte', p.qte ? String(p.qte) : '');
    choisir('s-type', p.rigide ? /Pancarte ou affiche/i : /kiss-cut/i);
    /* LE MATERIAU — ajoute le 11 septembre 2026, pour la bascule du
       plastique cannele au-dela de 25 exemplaires (voir scdm-limites.js).
       Absent du paquet, rien ne bouge : les anciennes demandes montees par
       la porte des colis n en portent pas, et le menu reste sur « Je ne
       sais pas — conseillez-moi ». */
    choisirLibelle('s-mat', p.matiereMotif);
    if (p.liens && p.liens.length) {
      poser('scdmUrls', p.liens.length + ' fichier' + (p.liens.length > 1 ? 's' : '') +
        ' : ' + p.liens.join(' · '));
    }

    /* On dit au client POURQUOI il est ici. Une redirection muette passe
       pour un bogue, et il repart. */
    var mot = document.createElement('p');
    mot.setAttribute('role', 'status');
    mot.style.cssText = 'margin:0 0 16px;padding:12px 14px;border:1px solid #FF7A18;' +
      'border-left-width:3px;border-radius:9px;background:rgba(255,122,24,.08);' +
      'font-size:14px;line-height:1.55';
    /* LA DEUXIEME PHRASE DEPEND DE LA RAISON. Une demande arrivee par la
       porte des colis attend un prix de TRANSPORT ; une demande arrivee par
       la bascule du volume attend un prix de PRODUIT. Dire au deuxieme
       qu on va appeler le transporteur ne veut rien dire pour lui. Le
       paquet peut donc porter sa propre suite ; sans elle, on garde mot
       pour mot celle d avant. */
    mot.innerHTML = '<b>Votre configuration a été reportée ici.</b> ' +
      'Cet envoi sort de notre grille de tarifs : ' +
      (p.motif || 'il demande plus d’un colis') + '. ' +
      (p.suite ||
       'Ajoutez vos coordonnées et envoyez-nous la demande : on confirme le prix du transport ' +
       'auprès du transporteur, puis on vous envoie une facture à payer en une seule fois.');
    var f = champ.form || document.querySelector('form[action*="contact"]');
    if (f && f.parentNode) f.parentNode.insertBefore(mot, f);
    try { mot.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
  }

  /* Chacune dans son propre try : une qui casse ne doit jamais emporter
     les deux autres. L ordre compte - deposerLaSoumission() ecrit la
     description, poserLeNumero() la prefixe ensuite. */
  function preparerLaSoumission() {
    try { deposerLaSoumission(); } catch (e) {}
    try { poserLeNumero(); } catch (e) {}
    try { reveillerLeBouton(); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', preparerLaSoumission);
  } else {
    preparerLaSoumission();
  }

  var D = window.SCDM_DATA;
  if (!D) return;

  D.VARIANTES = {};

  function argent(n) { return n.toFixed(2).replace('.', ',') + ' $'; }

  /* ==================================================================
     LE POIDS DU COLIS

     POURQUOI IL FAUT UNE DEUXIEME LIGNE. Le produit « Impression SCDM —
     commande » porte deja le MONTANT dans sa quantite : 65,45 $ = 6545
     unites a 0,01 $. Sa quantite est donc prise. Si on lui donnait un poids,
     Shopify le multiplierait par 6545 et le colis pesserait six tonnes.
     C est pour ca qu il pese zero — et c est pour ca que, sans ce qui suit,
     TOUT panier pese zero et retombe sur le tarif d expedition le moins cher.

     LA PARADE : une deuxieme ligne technique, a 0,00 $, dont la variante pese
     exactement UN GRAMME. On l ajoute avec une quantite egale au poids en
     grammes. 1409 unites = 1409 g = 1,409 kg. Shopify additionne les poids
     des lignes : le panier pese enfin ce qu il pese vraiment.

     CE QU ON COMPTE, depuis le 6 septembre 2026 : le POIDS FACTURABLE, et
     non le poids net. C est le plus eleve du poids reel (matiere, support et
     emballage) et du poids volumetrique du carton. Le detail est dans le bloc
     suivant. L emballage est compte UNE SEULE FOIS par commande, jamais une
     fois par design.

     D OU VIENNENT LES CHIFFRES. Fiches techniques des fabricants, relevees le
     6 septembre 2026, RECALCULEES ET CORRIGEES LE 11 SEPTEMBRE 2026 :
       - ACM 3 mm peaux 0,30 mm (Dibond, Alupanel) : 3,80 kg/m2 — EXACT,
         fiche 3A Composites, DIBOND Product Guide
       - Coroplast 4 mm blanc : 750 g/m2 +/- 5 % — EXACT, fiche Coroplast
       - Vinyle calandre applique, sans doublure : 125 g/m2, soit un film de
         0,080 mm x 1,25 g/cm3 plus un adhesif de 0,025 mm x 1,00. Le site
         portait 115 g/m2, ce qui est juste pour un film de 0,070 mm mais
         8 % TROP LEGER pour le 3,2 mil reellement imprime. Corrige.
       - Vinyle reflechissant : voir l avertissement sous la table POIDS.
         PERSONNE NE PUBLIE CE CHIFFRE.
     Converties ici en kg par PIED CARRE (1 pi2 = 0,092903 m2).

     ⚠️ CE QUI SE JOUE VRAIMENT ICI. Sur une piece SEULE, le poids
     VOLUMETRIQUE gagne toujours — verifie sur les 24 combinaisons de format
     et de support du catalogue, sans une seule exception. Un panneau, c est
     une grande boite presque vide. La matiere ne decide de la facture qu a
     L EMPILEMENT : dix panneaux de 24 x 36 po font 23 kg reels contre 7 kg
     volumetriques. C est la, et seulement la, que ces densites comptent.

     A VERIFIER UN JOUR : faire peser une vraie feuille d alupanel et une de
     coroplast. Un coroplast importe peut aller de 600 a 1200 g/m2 selon le
     fournisseur — l ecart change le palier d expedition. */

  var POIDS_VARIANTE = '52618410328344';   /* « Poids du colis », 0,00 $, 1 g */

  function colisDe(commande) { return window.SCDM_COLIS.colisDe(commande); }
  var SEUIL_LOURD_KG = window.SCDM_COLIS.seuilLourdKg;
  function nb2(n) { return n.toFixed(2).replace('.', ','); }

  function lignePoids(colis, ramasse, groupe, nombreDesigns) {
    if (!colis || !(colis.grammes > 0)) return Promise.resolve();
    var fd = new FormData();
    fd.append('id', POIDS_VARIANTE);
    fd.append('quantity', colis.grammes);
    fd.append('properties[_scdm_shipping_group]', groupe);
    fd.append('properties[_scdm_shipping_count]', nombreDesigns);
    fd.append('properties[Détail]',
      'Poids facturable — ' + nb2(colis.grammes / 1000) + ' kg' +
      (colis.nb > 1 ? ' · ' + colis.nb + ' colis' : ''));
    fd.append('properties[Colis suggéré]', colis.libelle);
    /* LE RAMASSAGE ACCEPTE, ECRIT SUR LA COMMANDE. Le client a passe la
       porte du colis lourd en disant qu il venait chercher sa commande :
       l atelier doit le savoir, parce que rien a la caisse ne l oblige a
       choisir « Ramassage » ensuite. Si le poids et le mode de livraison
       ne concordent pas, c est ici qu on le verra. */
    if (ramasse) {
      fd.append('properties[Expédition]',
        'Ramassage à l’atelier d’Alma choisi au configurateur — colis de ' +
        nb2(colis.grammes / 1000) + ' kg. Si la commande part en livraison, ' +
        'le tarif de transport doit être revérifié avant l’expédition.');
    }
    return envoi(fd);
  }

  /* Shopify refuse une ligne pour des raisons precises (produit non publie,
     fichier trop gros...). Il les dit dans le corps de la reponse. On les
     remonte au client au lieu d un message generique : sans ca, chaque panne
     ressemble a la precedente et on ne sait pas quoi reparer. */
  function envoi(fd) {
    return fetch('/cart/add.js', { method: 'POST', body: fd }).then(function (r) {
      if (r.ok) return r;
      return r.json().then(function (j) { return j; }, function () { return {}; })
        .then(function (j) {
          var e = new Error('panier');
          e.status = r.status;
          e.motif = j.description || j.message || ('Le panier a repondu ' + r.status + '.');
          throw e;
        });
    });
  }

  /* Une image encodee en texte (data:image/png;base64,...) redevient un vrai
     fichier. Shopify n accepte que de vrais fichiers dans une propriete de
     ligne : c est ce qui lui fait stocker l image et afficher la vignette
     cliquable sur la commande. */
  function versFichier(dataURL, nom) {
    if (!dataURL) return null;
    try {
      var v = String(dataURL).split(',');
      var mime = (v[0].match(/:(.*?);/) || [])[1] || 'image/png';
      var bin = atob(v[1]);
      var oct = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) oct[i] = bin.charCodeAt(i);
      return new File([oct], nom, { type: mime });
    } catch (e) {
      return null;                 /* une epreuve manquante ne bloque pas la vente */
    }
  }

  function ligne(cents, props, fichier, epreuve) {
    var fd = new FormData();
    fd.append('id', D.SUPPLEMENT);
    fd.append('quantity', Math.max(1, cents));
    Object.keys(props).forEach(function (k) {
      if (props[k]) fd.append('properties[' + k + ']', props[k]);
    });
    if (fichier) fd.append('properties[Fichier]', fichier);
    /* L EPREUVE — le dessin du client AVEC sa ligne de coupe magenta. Sans
       elle, l atelier ne voit que le fichier brut et doit deviner ou passera
       la lame. Voir composer() dans scdm.js. */
    if (epreuve) fd.append('properties[Épreuve — ligne de coupe]', epreuve);
    return envoi(fd);
  }

  /* scdm.js range le code dans le libelle du rabais (« Code POF27 — 10 % »).
     On le ressort tel quel pour l ecrire sur la commande. */
  function codeDe(applique) {
    if (!applique || applique.type !== 'code') return '';
    var m = String(applique.nom || '').match(/^Code\s+(\S+)/);
    return m ? m[1] : '';
  }

  /* ==================================================================
     LA PORTE - CE QUI NE TIENT PAS DANS LA GRILLE PART EN SOUMISSION

     POURQUOI. Les 18 paliers d expedition s arretent a « 20 kg et plus »,
     un palier plat. Une commande de cinq colis, dont trois
     surdimensionnes, y tomberait au meme prix qu un colis de 21 kg. On ne
     peut pas annoncer un prix qu on ne connait pas : on arrete la commande
     AVANT la caisse et on la transforme en demande de soumission.

     LE PARCOURS, decide le 9 septembre :
       1. le bouton devient « Demander une soumission » ;
       2. les fichiers du client et les epreuves sont televerses ici, pour
          que la demande parte complete ;
       3. le resume s ecrit dans sessionStorage et la page va sur
          /pages/soumission, ou deposerLaSoumission() le pose ;
       4. l atelier confirme le transport aupres du transporteur ;
       5. une FACTURE PROVISOIRE Shopify porte le vrai montant, et le
          client paie une seule fois, le bon prix.

     ⚠️ RIEN N EST COMMANDE NI PAYE dans ce parcours. Le panier reste vide.
     ================================================================== */

  var VARIANTE_TELEVERSEMENT = '52593530405144';   /* « Téléversement de fichier » */
  var RACINE_BOUTIQUE = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
  var PAGE_SOUMISSION = RACINE_BOUTIQUE + 'pages/soumission';
  var CLE_SOUMISSION = 'scdmSoumissionAuto';

  /* Le meme chemin que la page de soumission utilise : on ajoute une ligne
     technique au panier pour que Shopify range le fichier, on lit son
     adresse, puis ON RETIRE LA LIGNE. Sans ce retrait, le client verrait
     un jour sur sa facture un article qu il n a jamais demande - c est
     arrive a la commande #1006. */
  function televerser(f) {
    if (!f) return Promise.resolve('');
    var fd = new FormData();
    fd.append('id', VARIANTE_TELEVERSEMENT);
    fd.append('quantity', 1);
    fd.append('properties[Fichier]', f);
    return fetch('/cart/add.js', { method: 'POST', body: fd })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j) return '';
        if (j.key) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: j.key, quantity: 0 })
          }).catch(function () {});
        }
        return (j.properties && j.properties['Fichier']) || '';
      })
      .catch(function () { return ''; });
  }

  function motifDe(c) {
    if (c.nb > 1 && c.surdim) {
      return 'il demande ' + c.nb + ' colis, dont ' + c.surdim +
             ' surdimensionné' + (c.surdim > 1 ? 's' : '');
    }
    if (c.nb > 1) return 'il demande ' + c.nb + ' colis';
    if (c.surdim) return 'le colis est surdimensionné';
    /* LE COLIS LOURD. En dernier : un colis surdimensionne l est d abord,
       meme s il est aussi lourd - c est la dimension qui coute le plus cher
       chez le transporteur. Voir SEUIL_LOURD_KG. */
    if (c.lourd) {
      return 'le colis pèse ' + nb2(c.grammes / 1000) + ' kg, au-delà des ' +
             SEUIL_LOURD_KG + ' kg où nos paliers d’expédition s’arrêtent';
    }
    return 'le colis est surdimensionné';
  }

  /* Les proprietes techniques (celles qui commencent par un soulignement)
     sont ecrites ICI en toutes lettres : c est l atelier qui lit, pas le
     client, et sans elles le cadrage approuve serait perdu. */
  /* « Couleur du vinyle » suit le Materiau, comme a l ecran et comme dans
     proprietes() de scdm.js : elle ne parait que sur du lettrage decoupe, et
     c est elle qui dit a l atelier QUEL ROULEAU monter. Une cle absente est
     simplement sautee par la boucle ci-dessous — rien a proteger de plus. */
  var LIGNES_FICHE = ['Grandeur réelle', 'Quantité', 'Forme', 'Matériau',
                      'Couleur du vinyle', 'Finition',
                      'Laminage', 'Support', 'Contour de coupe', 'Délai',
                      'Ruban de transfert', 'Surface de ruban facturée',
                      'Ruban — fourniture', 'Ruban — application en atelier',
                      'Ruban — préparation du design', 'Supplément ruban et application',
                      '_Cadrage', '_Fichier — pixels'];

  function resumePour(commande, colis, t) {
    var L = [];
    L.push('DEMANDE MONTÉE DANS LE CONFIGURATEUR');
    L.push('Cet envoi sort de la grille de tarifs : ' + motifDe(colis) + '.');
    L.push('');
    commande.forEach(function (d, i) {
      L.push((i + 1) + '. ' + d.nom);
      L.push('   ' + d.resume);
      if (d.props) {
        LIGNES_FICHE.forEach(function (k) {
          if (d.props[k]) L.push('   ' + k.replace(/^_/, '') + ' : ' + d.props[k]);
        });
        Object.keys(d.props).forEach(function (k) {
          if (k.indexOf('Option — ') === 0 && d.props[k]) L.push('   ' + k + ' : ' + d.props[k]);
        });
      }
      L.push('   Prix du design : ' + argent(d.total));
      if (d.lienFichier) L.push('   Fichier du client : ' + d.lienFichier);
      if (d.lienEpreuve) L.push('   Épreuve : ' + d.lienEpreuve);
      L.push('');
    });
    if (t.montage > 0) {
      L.push('Montage du laminage (une seule fois pour la commande) : ' + argent(t.montage));
      L.push('');
    }
    L.push('Total marchandise : ' + argent(t.total) + ' (avant transport et taxes)');
    L.push('');
    L.push('EXPÉDITION — À CONFIRMER AUPRÈS DU TRANSPORTEUR');
    L.push('   ' + colis.libelle);
    L.push('   Poids facturable calculé : ' + nb2(colis.grammes / 1000) + ' kg');
    L.push('   Nombre de colis : ' + colis.nb +
           (colis.surdim ? ' · dont ' + colis.surdim + ' surdimensionné' +
            (colis.surdim > 1 ? 's' : '') : ''));
    return L.join('\n');
  }

  function versSoumission(S, colis, t) {
    var b = document.getElementById('scdmApproSuite');
    var err = document.getElementById('scdmApproErreur');
    if (b) { b.disabled = true; b.textContent = 'Préparation de la demande…'; }
    if (err) {
      err.className = 'ap-erreur on';
      err.textContent = 'Cet envoi sort de notre grille de tarifs : ' + motifDe(colis) +
        '. On vous emmène à la demande de soumission — rien n’est commandé ni payé.';
    }

    var liens = [];
    var chaine = Promise.resolve();
    S.commande.forEach(function (d, i) {
      chaine = chaine.then(function () {
        return televerser(d.fichier).then(function (u) {
          if (u) { d.lienFichier = u; liens.push(u); }
          return televerser(versFichier(d.epreuve, 'epreuve-' + (i + 1) + '-ligne-de-coupe.png'));
        }).then(function (u2) {
          if (u2) { d.lienEpreuve = u2; liens.push(u2); }
        });
      });
    });

    return chaine.catch(function () { /* un fichier manquant ne bloque pas la demande */ })
      .then(function () {
        var paquet = {
          resume: resumePour(S.commande, colis, t),
          format: S.commande.map(function (d) { return d.formatLabel; }).join(' · '),
          qte: S.commande.reduce(function (n, d) { return n + (Number(d.qte) || 0); }, 0),
          rigide: S.commande.some(function (d) {
            return /alupanel|coroplast/i.test(String((d.props && d.props['Support']) || ''));
          }),
          motif: motifDe(colis),
          liens: liens
        };
        try { sessionStorage.setItem(CLE_SOUMISSION, JSON.stringify(paquet)); } catch (e) {}
        window.location.href = PAGE_SOUMISSION;
      });
  }

  /* ==================================================================
     LE COLIS LOURD — ON DEMANDE AVANT DE DECIDER

     Deux sorties, offertes en meme temps ; on ne choisit pas a sa place.

       1. IL RAMASSE A L ATELIER D ALMA. Le poids n a alors aucune
          importance : pas de transporteur, pas de carburant, pas de
          palier. Il poursuit vers la caisse comme avant. C est souvent la
          bonne reponse pour un gros colis, et la lui refuser serait perdre
          une commande qui ne coute rien a livrer.
       2. IL VEUT QUE CA PARTE. On ne peut pas annoncer un prix de
          transport qu on n a pas verifie : la demande part en soumission
          par le meme chemin que les colis multiples.
     ================================================================== */
  /* LE CHOIX DU CLIENT EST ATTACHE A SA COMMANDE, PAS A SA SESSION. Il dit
     « je ramasse » pour LA commande qu il a sous les yeux ; s il retourne en
     arriere et ajoute trois panneaux, la question se repose. Sans ca, un
     « oui » donne a 21 kg vaudrait encore a 29. */
  var ramassagePour = '';

  function signatureCommande(S) {
    return (S.commande || []).map(function (d) {
      return [d.aire, d.qte, d.matiere, d.laminage,
              (d.props && d.props['Support']) || ''].join('|');
    }).join('//');
  }

  function boutonChoix(id, texte, principal) {
    return '<button type="button" id="' + id + '" class="scdm-choix' +
           (principal ? ' principal' : '') + '">' + texte + '</button>';
  }

  function styleChoix() {
    if (document.getElementById('scdmChoixStyle')) return;
    var s = document.createElement('style');
    s.id = 'scdmChoixStyle';
    s.textContent = [
      '.scdm-choix{display:block;width:100%;margin:8px 0 0;padding:11px 16px;',
      'border:1.5px solid currentColor;border-radius:9px;background:transparent;',
      'color:inherit;font:inherit;font-size:14px;font-weight:600;cursor:pointer;line-height:1.3}',
      '.scdm-choix.principal{background:#FF7A18;border-color:#FF7A18;color:#2A1607}',
      '.scdm-choix:hover{filter:brightness(1.1)}',
      '.scdm-choix:focus-visible{outline:2px solid currentColor;outline-offset:2px}'
    ].join('');
    document.head.appendChild(s);
  }

  function proposerLeChoix(S, colis, t) {
    styleChoix();
    var b = document.getElementById('scdmApproSuite');
    var err = document.getElementById('scdmApproErreur');
    if (b) { b.disabled = true; }
    if (!err) {
      /* Pas d ecran d approbation sous la main : on ne bloque pas la vente,
         on part en soumission comme pour un colis hors grille. Mieux vaut
         une demande de trop qu un tarif qu on n a pas verifie. */
      return versSoumission(S, colis, t);
    }
    err.className = 'ap-erreur on';
    err.innerHTML =
      '<b>Votre commande fait un colis de ' + nb2(colis.grammes / 1000) + ' kg.</b> ' +
      'Nos paliers d’expédition s’arrêtent à ' + SEUIL_LOURD_KG + ' kg : au-delà, ' +
      'le tarif de transport se confirme au cas par cas, auprès du transporteur.' +
      '<p style="margin:10px 0 0"><b>La cueillette à l’atelier d’Alma reste gratuite</b>, ' +
      'quel que soit le poids. Si vous venez chercher votre commande, rien ne change : ' +
      'poursuivez et choisissez « Ramassage » à la caisse.</p>' +
      boutonChoix('scdmChoixRamassage', 'Je ramasse à Alma — poursuivre vers la caisse', true) +
      boutonChoix('scdmChoixSoumission', 'Faites-le expédier — demander une soumission', false);
    try { err.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}

    var r = document.getElementById('scdmChoixRamassage');
    var s = document.getElementById('scdmChoixSoumission');
    if (r) r.addEventListener('click', function () {
      ramassagePour = signatureCommande(S);
      err.className = 'ap-erreur';
      err.innerHTML = '';
      if (b) b.disabled = false;
      envoyer();
    });
    if (s) s.addEventListener('click', function () {
      versSoumission(S, colis, t);
    });
  }

  var reprisePoids = null;
  var envoiEnCours = false;

  function messagePanierAVerifier() {
    return /^en(?:-|$)/i.test(document.documentElement.lang || '') ?
      'This request may already be in your cart. Review your cart before starting again.' :
      'Cette demande est peut-être déjà dans votre panier. Vérifiez votre panier avant de recommencer.';
  }

  function envoyer() {
    if (document.getElementById('scdmInterneRacine')) return;
    if (envoiEnCours) return;
    var S = window.SCDM;
    if (!S || !S.commande || !S.commande.length) return;

    var b = document.getElementById('scdmApproSuite');
    var err = document.getElementById('scdmApproErreur');
    if (b) { b.disabled = true; b.textContent = 'Envoi en cours…'; }
    if (err) { err.className = 'ap-erreur'; err.textContent = ''; }

    var t = S.totaux();

    /* ⚠️ LA PORTE. Tout ce qui demande plus d un colis, ou un colis
       surdimensionne, ne va pas a la caisse : on ne peut pas annoncer un
       prix de transport qu on ne connait pas. Voir versSoumission(). */
    var groupeExpedition = reprisePoids && reprisePoids.groupe ||
      (Date.now().toString(36) + '-' + Math.random().toString(36).slice(2));
    var descriptionsExpedition, colis;
    try {
      descriptionsExpedition = S.commande.map(function (d, i) {
        return window.SCDM_COLIS.descriptor(d, groupeExpedition, i);
      });
      colis = colisDe(S.commande);
    } catch (e) {
      if (b) { b.disabled = false; b.textContent = b.dataset.libelle || 'Approuver et poursuivre'; }
      if (err) {
        err.className = 'ap-erreur on';
        err.textContent = /^en(?:-|$)/i.test(document.documentElement.lang || '') ?
          'Please configure this design again so its shipping dimensions can be verified.' :
          'Veuillez configurer ce design de nouveau pour vérifier ses dimensions d’expédition.';
      }
      return;
    }
    if (colis.horsGrille) { return versSoumission(S, colis, t); }

    /* ⚠️ LA DEUXIEME PORTE — LE COLIS LOURD. Un seul carton, aux bonnes
       dimensions, mais au-dela du dernier palier borne de la grille. On ne
       tranche pas a la place du client : on lui montre les deux sorties,
       parce que le ramassage a l atelier rend le poids sans importance.
       Voir SEUIL_LOURD_KG et proposerLeChoix(). */
    var ramasse = colis.lourd && ramassagePour === signatureCommande(S);
    if (colis.lourd && !ramasse) { return proposerLeChoix(S, colis, t); }

    var pct = (t.applique && t.applique.pct) || 0;
    var nomRabais = t.applique ? t.applique.nom : '';
    var code = codeDe(t.applique);

    var cents = S.commande.map(function (d) { return Math.round(d.total * (1 - pct) * 100); });
    var centsMin = Math.round(t.plancher * (1 - pct) * 100);
    /* LE MONTAGE DU LAMINAGE. Un frais d atelier compte UNE SEULE FOIS pour
       toute la commande (scdm.js, montageLaminage()) : il ne peut donc pas
       vivre sur la ligne d un design. Il part comme l ajustement de minimum,
       sur sa propre ligne, avec son motif ecrit en toutes lettres. */
    var centsMontage = Math.round((t.montage || 0) * (1 - pct) * 100);
    var cible = Math.round(t.total * 100);
    var somme = cents.reduce(function (s, n) { return s + n; }, 0) + centsMin + centsMontage;
    if (cents.length) cents[0] += (cible - somme);

    var signature = JSON.stringify({ commande: S.commande, totaux: t, colis: colis, ramasse: ramasse });
    var fichiers = S.commande.map(function (d) { return d.fichier; });
    if (reprisePoids && (reprisePoids.bloquee || reprisePoids.signature !== signature ||
        fichiers.some(function (f, i) { return f !== reprisePoids.fichiers[i]; }))) {
      if (err) {
        err.className = 'ap-erreur on';
        err.textContent = messagePanierAVerifier();
      }
      return;
    }
    envoiEnCours = true;

    var chaine = Promise.resolve();
    if (!reprisePoids) {
    S.commande.forEach(function (d, i) {
      chaine = chaine.then(function () {
        var props = {};
        Object.keys(d.props).forEach(function (k) { props[k] = d.props[k]; });
        props['Prix du design'] = argent(d.total);
        props['_scdm_shipping_group'] = groupeExpedition;
        props['_scdm_shipping_v1'] = JSON.stringify(descriptionsExpedition[i]);
        if (pct) {
          props['Rabais'] = nomRabais + ' · −' + argent(d.total * pct);
          if (code) props['Code promo'] = code;
        }
        return ligne(cents[i], props, d.fichier,
          versFichier(d.epreuve, 'epreuve-' + (i + 1) + '-ligne-de-coupe.png'));
      });
    });

    chaine = chaine.then(function () {
      if (centsMontage > 0) {
        return ligne(centsMontage, {
          'Détail': 'Montage du laminage — passe de lamination, une seule fois par commande'
        }, null);
      }
    }).then(function () {
      if (centsMin > 0) {
        return ligne(centsMin, {
          'Détail': 'Ajustement — minimum de commande de ' + (D.MIN_COMMANDE || 40) + ' $'
        }, null);
      }
    });
    }
    chaine.then(function () {
      reprisePoids = { signature: signature, fichiers: fichiers, groupe: groupeExpedition };
      return lignePoids(colis, ramasse, groupeExpedition, S.commande.length);
    }).then(function () {
      /* Plus de detour par /discount/CODE : Shopify n a plus de code a
         appliquer, et le montant est deja bon. */
      window.location.href = RACINE_BOUTIQUE + 'checkout';
    }).catch(function (e) {
      envoiEnCours = false;
      if (reprisePoids && !(e && (e.status === 400 || e.status === 404 || e.status === 422))) {
        reprisePoids.bloquee = true;
        if (b) b.disabled = true;
        if (err) { err.className = 'ap-erreur on'; err.textContent = messagePanierAVerifier(); }
        return;
      }
      if (b) { b.disabled = false; b.textContent = b.dataset.libelle || 'Approuver et poursuivre'; }
      if (err) {
        err.className = 'ap-erreur on';
        /* Aucune adresse ecrite ici : le message part en textContent, donc un
           lien HTML ne fonctionnerait pas, et une adresse en clair serait
           moissonnee par les robots. On renvoie a la page Nous joindre, ou
           l adresse est protegee par scdm-courriel.js. */
        err.textContent = (e && e.motif ? e.motif + ' ' : '') +
          "L'envoi n'a pas fonctionné. Réessayez, ou écrivez-nous par la page « Nous joindre » du site.";
      }
    });
  }

  /* En CAPTURE sur le document, donc avant le gestionnaire que scdm.js pose
     sur ce meme bouton. On coupe la propagation : c est nous qui envoyons. */
  document.addEventListener('click', function (e) {
    var b = (e.target && e.target.closest) ? e.target.closest('#scdmApproSuite') : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    envoyer();
  }, true);
})();
